import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, openModal } from 'redux/modal';
import EventEmitter from 'events';

export const modalEvents = new EventEmitter();

const useModal = (modalName) => {
    /* Helpers */
    const dispatch = useDispatch();

    /* Selectors */
    const isOpen = useSelector((state) => state.modal.modals[modalName].open);
  
    /* Functions */
    const closeModalHandler = useCallback((data) => {
      dispatch(closeModal(modalName, data));
      modalEvents.emit(`closeModal:${modalName}`, data);
    }, [dispatch, modalName]);

    const openModalHandler = useCallback((data) => {
      dispatch(openModal(modalName, data));
      modalEvents.emit(`openModal:${modalName}`, data);
    }, [dispatch, modalName]);

    return [isOpen, closeModalHandler, openModalHandler];
};

export default useModal;